import { call, put } from 'redux-saga/effects';
import { authenticateSaga } from '@/modules/casino/store/sagas/authentication';
import { IS_SEAMLESS_TOKEN, IS_SHORT_SEAMLESS_TOKEN } from '@/modules/casino/utils/LoginMethods';
import * as actions from '@/modules/casino/store/actions';

export function* tryJWTLogin() {
  const urlParams = new URLSearchParams(window.location.search);
  const isFlutterEnv = urlParams.get('appEnv') === 'flutter';
  const jwtParam = urlParams.get('jwt');

  // Handle Flutter environment authentication
  if (jwtParam) {
    // Remove JWT from URL to prevent re-authentication
    const url = new URL(window.location.href);
    url.searchParams.delete('jwt');
    window.history.replaceState({}, document.title, url.toString());
    if (isFlutterEnv) {
      try {
        const jwt = JSON.parse(jwtParam);
        // Check for all necessary JWT properties
        if (jwt.accessToken && jwt.tokenType && jwt.expiresIn && jwt.refreshToken && jwt.authType && jwt.authDate) {
          const data = {
            access_token: jwt.accessToken,
            token_type: jwt.tokenType,
            expires_in: jwt.expiresIn,
            refresh_token: jwt.refreshToken,
            auth_date: jwt.authDate,
            // Assuming authType from JWT should be used, otherwise set explicitly if needed
            auth_type: jwt.authType === 'token' ? 'user' : jwt.authType,
          };
          //@ts-ignore
          yield call(authenticateSaga, data);
          return true; // Authenticated via JWT, exit
        }
      } catch (e) {
        console.error('Failed to parse JWT from URL:', e);
        // Fall through to guest token if JWT parsing/validation fails
      }
    }
  }

  return false;
}

export function* tryGuestTokenLogin() {
  if (window.config.guestToken) {
    const guestData = {
      access_token: window.config.guestToken,
      expires_in: 3600 * 24 * 365,
      token_type: 'Bearer',
      scope: null,
      auth_type: 'app', // Explicitly guest/app type
    };
    // @ts-ignore
    yield call(authenticateSaga, guestData);
    return true; // Authenticated as guest, exit
  }
  return false;
}

export function* trySeamlessLogin() {
  const params = {
    UserInfo: IS_SHORT_SEAMLESS_TOKEN, // poker app
    shortToken: IS_SHORT_SEAMLESS_TOKEN,
    etok: IS_SEAMLESS_TOKEN,
  };
  // foreach  key value of params
  for (const [param, authType] of Object.entries(params)) {
    const token = new URLSearchParams(window.location.search).get(param);
    if (token) {
      // remove token from url
      const url = new URL(window.location.href);
      url.searchParams.delete(param);
      window.history.replaceState({}, document.title, url.toString());

      // @ts-ignore
      yield put(actions.loginMethod(authType));
      yield put(actions.loginPassword(token));
      yield put(actions.loginStart(undefined));
      return true; // Authenticated via seamless login, exit
    }
  }
  return false; // No seamless login token found
}
